export default "__VITE_ASSET__C8wc_vw2__"